import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { apiEndpoints } from 'src/app/api-endpoints';
import {
  DemoRequest,
  ContactRequest,
  PricingRequest,
  ContactResponse
} from './models/contact.model';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private apiUrl = environment.apiConfig.baseUri + apiEndpoints.contact;

  private apis = {
    demo: '/demo',
    contact: '/contact',
    pricing: '/pricing'
  }

  constructor(private http: HttpClient) {}

  /**
   * Submit a demo request (MOCKED - No backend call)
   * TODO: Replace with real HTTP call when backend is ready
   * @param request Demo request data
   * @returns Observable of contact response
   */
  submitDemoRequest(request: DemoRequest): Observable<ContactResponse> {

    // TODO: Replace with real HTTP call
    // return this.http.post<ContactResponse>(
    //   `${this.apiUrl}${this.apis.demo}`,
    //   request
    // );

    // Simulate network delay
    return of({
      code: 200,
      message: 'Demo request submitted successfully!',
      timestamp: new Date()
    } as ContactResponse).pipe(delay(500)); // 500ms delay to simulate network call
  }

  /**
   * Submit a contact form (MOCKED - No backend call)
   * TODO: Replace with real HTTP call when backend is ready
   * @param request Contact request data
   * @returns Observable of contact response
   */
  submitContactRequest(request: ContactRequest): Observable<ContactResponse> {

    // TODO: Replace with real HTTP call
    // return this.http.post<ContactResponse>(
    //   `${this.apiUrl}${this.apis.contact}`,
    //   request
    // );

    // Simulate network delay
    return of({
      code: 200,
      message: 'Contact message submitted successfully!',
      timestamp: new Date()
    } as ContactResponse).pipe(delay(500)); // 500ms delay to simulate network call
  }

  /**
   * Submit a pricing consultation request (MOCKED - No backend call)
   * TODO: Replace with real HTTP call when backend is ready
   * @param request Pricing request data
   * @returns Observable of contact response
   */
  submitPricingRequest(request: PricingRequest): Observable<ContactResponse> {

    // TODO: Replace with real HTTP call
    // return this.http.post<ContactResponse>(
    //   `${this.apiUrl}${this.apis.pricing}`,
    //   request
    // );

    // Simulate network delay
    return of({
      code: 200,
      message: 'Pricing consultation request submitted successfully!',
      timestamp: new Date()
    } as ContactResponse).pipe(delay(500)); // 500ms delay to simulate network call
  }
}
